import { BaseGetRequest } from './core/baseGetRequest';
import { Authentication } from './core/baseRequest';
import { AirportsList, AirportsListDynamicType } from '../models/airportsList';

export class AirportsRequest extends BaseGetRequest<AirportsList> {
    constructor(public searchString: string) {
        super('airports', {searchString}, AirportsListDynamicType, Authentication.SharingToken);
    }
}
